import axios from "./axios.tsx";
import type {
  SyncStatus,
  SyncIntegrationResponse,
  ActiveIntegrationSyncResponse,
  ApiResponse,
} from "../types";
import { BASE_URL } from "../const.ts";

/**
 * Trigger a manual sync for a specific integration.
 */
export function syncIntegration(
  integration_identifier: string,
): Promise<ApiResponse<SyncIntegrationResponse>> {
  return axios.post(
    "/v1/integrations/sync/",
    JSON.stringify({ integration_identifier }),
    { withCredentials: true },
  );
}

/**
 * Fetch the latest sync status for a specific integration.
 */
export async function fetchIntegrationSyncStatus(
  integration_identifier: string,
): Promise<SyncStatus | null> {
  const response = await axios.get<{ objects: SyncStatus[]; type: string }>(
    `/v1/integrations/sync_status/?integration=${integration_identifier}`,
  );
  return response.data.objects[0] || null;
}

/**
 * Fetch active sync metadata for a specific integration, if any.
 */
export async function fetchActiveIntegrationSync(
  integration_identifier: string,
) {
  const response = await axios.get<ActiveIntegrationSyncResponse>(
    `/v1/integrations/sync/active/${integration_identifier}/`,
  );
  return response.data.active_sync;
}

/**
 * Build the SSE URL for streaming sync status updates.
 */
export function buildIntegrationSyncStreamUrl(
  integration_identifier: string,
  signed_value: string,
  sync_id: string,
): string {
  return `${BASE_URL}/v1/integrations/sync/stream/${integration_identifier}/?user_signature=${encodeURIComponent(signed_value)}&sync_id=${encodeURIComponent(sync_id)}`;
}
